import { useAtomValue } from "jotai";
import { useRouter } from "@/utils";
import { clsx } from "clsx";
import { labelingParamsAtom } from "../../state";
import { FileNode } from "./FileNode";

export function LabeledFileItem({
    id,
    date,
    showCircle = true,
}: {
    id: string;
    date: string;
    showCircle?: boolean;
}) {
    const router = useRouter();
    const companyId = router.params.companyId as string;
    const { selectedFileId, selectedDraftId } =
        useAtomValue(labelingParamsAtom);
    const isSelected = selectedFileId === id && !selectedDraftId;

    return (
        <li className={clsx("py-0.5")}>
            <FileNode
                icon={showCircle ? "check" : "none"}
                label="Labeled file"
                id={id}
                date={date}
                to={`/beta/companies/${companyId}/labeling/files/${id}`}
                isSelected={isSelected}
            />
        </li>
    );
}
